<div class="header-icon" [class]="'bg-' + companyData().key">
  {{companyData().short}}
</div>
